import React from 'react';
import styled from 'styled-components';
import { lightGrey1Color, lightGrey3Color, clearFix } from 'js/config/style';
import { Link } from '@reach/router';

export default styled(({ to, children, ...rest }) => (
  <div {...rest}>
    <Link to={to}>{children}</Link>
  </div>
))`
  a {
    position: relative;
    padding: 1rem 0 1rem 1rem;
    overflow: hidden;
    ${clearFix}
    cursor: pointer;
    color: ${lightGrey3Color};
    display: grid;
    grid-template-rows: auto auto;
    grid-template-columns: auto 1fr auto;
    grid-template-areas:
      'image date goto'
      'image title goto';
    grid-column-gap: 1rem;

    &:hover {
      color: ${lightGrey3Color.darken()};
      background: ${lightGrey1Color};
      text-decoration: none;
    }

    &:last-child {
      border-radius: 0 0 0.25rem 0.25rem;
    }

    &:active {
      background: ${lightGrey1Color.darken(0.1)};
    }

    && + && {
      border-top: 1px solid ${lightGrey1Color};
    }
  }
`;
